import React, { useEffect, useState } from 'react';
import { Image, List, Popup } from 'antd-mobile';
import {ClockCircleOutlined, ExclamationCircleOutlined, PoweroffOutlined, SettingOutlined} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getUserInfo, logout } from 'utils/auth';
import { RegisterAvatarIcon } from '../../../assets/icons';
import { getAppVersion } from 'utils/appRuntime';
import { getNavBarContainerStyle } from '../../../utils/deviceUtils';
import {t} from "../../../i18n";
import {TmsPath} from "../../../enums/TmsNavigatePathEnum";

interface TransportMenuDrawerProps {
    visible: boolean;
    onClose: () => void;
}

const TransportMenuDrawer: React.FC<TransportMenuDrawerProps> = ({ visible, onClose }) => {
    const navigate = useNavigate();
    const [appVersion, setAppVersion] = useState<string>('V1.0');

    useEffect(() => {
        getAppVersion().then(setAppVersion).catch(() => setAppVersion('V1.0'));
    }, []);

    const userInfo = getUserInfo();
    const userName = userInfo?.account?.name;
    const userAvatar = userInfo?.account?.avatarUrl;

    return (
        <Popup position="left" visible={visible} onClose={onClose} closeOnMaskClick>
            <div {...getNavBarContainerStyle('p-4 h-full flex flex-col')}>
                {/* 用户信息 */}
                <div className="flex items-center mb-4">
                    <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 text-xl overflow-hidden">
                        {userAvatar ? (
                            <Image src={userAvatar} width={64} height={64} fit="cover" style={{ borderRadius: 32 }} />
                        ) : (
                            <RegisterAvatarIcon className="w-12 h-12" />
                        )}
                    </div>
                    <div className="ml-3">
                        <div className="font-medium text-base">{userName}</div>
                    </div>
                </div>

                {/* 菜单项 */}
                <List className="flex-grow" style={{ '--border-bottom': 'none', '--border-top': 'none' } as any}>

                    <List.Item prefix={<ClockCircleOutlined/>} onClick={() => {
                        navigate(TmsPath.TMS_TRANSPORT_FINISHED)
                    }}>
                        {t('pages.tms.finished.title')}
                    </List.Item>
                    <List.Item
                        prefix={<ExclamationCircleOutlined style={{color: 'red'}}/>}
                        onClick={() => {
                            navigate(TmsPath.TMS_TRANSPORT_EXCEPTION_REPORTED)
                        }}
                    >
                        {t('pages.tms.exceptionRecord')}
                    </List.Item>
                    <List.Item prefix={<SettingOutlined/>} onClick={() => {
                        navigate(TmsPath.TMS_TRANSPORT_SETTINGS)
                    }}>
                        {t('pages.tms.settings')}
                    </List.Item>
                </List>

                {/* 底部 */}
                <div className="mt-auto w-full">
                    <List style={{ '--border-top': 'none' } as any}>
                        <List.Item
                            prefix={<PoweroffOutlined />}
                            onClick={() => {
                                logout('/login');
                            }}
                        >
                            {t('pages.tms.signOut')}
                        </List.Item>
                    </List>
                    <div className="flex p-2 text-gray-500">{appVersion}</div>
                </div>
            </div>
        </Popup>
    );
};

export default TransportMenuDrawer;


